<template>
   <!-- 添加导航触发区域 -->
    <ProductNavigation />

  <!-- 产品页面头部section -->
  <section class="product-hero-section">
      
    </section>

  <div class="product-detail-page">
    <div class="product-button-container">
    <button class="back-button" @click="$router.go(-1)">{{ t('productDetail.back') }}</button>
    </div>
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-spinner">{{ t('common.loading') }}</div>

    <!-- 错误状态 -->
    <div v-else-if="error" class="error-message">
      <p>{{ t('productDetail.loadError') }}: {{ error }}</p>
      <button @click="loadProductDetail">{{ t('common.retry') }}</button>
    </div>

    <!-- 产品内容 - 确保product存在才渲染 -->
    <div v-else-if="product" class="product-detail-container">
      <!-- 产品核心特点标签 -->
  
      <!-- 产品标题和图片部分 -->
      <div class="product-header-container">
        <!-- 左侧标题区域 -->
        <div class="product-title-container">
          <h1>{{ product.title }}</h1>
          <!-- <p class="product-brief">{{ product.briefDescription }}</p> -->
          
          <!-- 移动产品概览到这里 -->
          <div class="overview-section">
            <div class="product-description" v-html="formattedDescription"></div>
          </div>
        </div>

        <!-- 右侧图片与热区容器 -->
        <div class="product-image-container">
          <!-- 图片切换控制按钮 - 使用Element图标 -->
          <button 
            class="image-nav-btn prev-btn"
            @click="prevImage"
            :disabled="currentImageIndex === 0"
          >
            <ElIcon>
              <ArrowLeft />
            </ElIcon>
          </button>
  
          <!-- 图片显示区域 -->
          <div class="image-carousel">
            <img 
              ref="productImage"
              :src="currentImageUrl || '@/assets/product1.png'"
              :alt="product.title"
              usemap="#product-map"
              class="product-main-image"
              @load="adjustHotspots"
            >
          </div>
  
          <!-- 图片切换控制按钮 - 使用Element图标 -->
          <button 
            class="image-nav-btn next-btn"
            @click="nextImage"
            :disabled="currentImageIndex >= imageCount - 1"
          >
            <ElIcon>
              <ArrowRight />
            </ElIcon>
          </button>
  
          <!-- 图片指示器 -->
          <div class="image-indicators" v-if="product?.imageUrls?.length > 0">
            <span 
              v-for="(img, index) in product.imageUrls"
              :key="index"
              :class="{ 'active': index === currentImageIndex }"
              @click="switchToImage(index)"
            ></span>
          </div>
  
          <!-- 热区视觉提示覆盖层 -->
          <!-- <div class="hotspot-overlay" v-if="product.components">
            <div 
              v-for="(component, index) in product.components" 
              :key="index" 
              :class="['hotspot-visual', `shape-${component.shape || 'rect'}`]"
              :style="getHotspotStyle(component)"
              :title="component.name"
              @mouseenter="showComponentDetails(component, $event)"
              @mouseleave="hideComponentDetails()"
              @mousemove="updateTooltipPosition($event)"
            >
            </div>
          </div> -->
          <!-- 图片热区定义 -->
          <!-- <map name="product-map" v-if="product.components">
            <area 
              v-for="(component, index) in product.components" 
              :key="index" 
              :shape="component.shape || 'rect'"
              :coords="getScaledCoords(component)"
              :alt="component.name"
            />
          </map> -->
          <!-- 组件详情悬浮框 -->
          <div 
            v-if="showTooltip"
            class="component-details-tooltip"
            :style="tooltipStyle"
            ref="tooltipElement"
          >
            <h3 class="tooltip-title">{{ tooltipContent.name }}</h3>
            <div class="tooltip-content">
              <p>{{ tooltipContent.description }}</p>
              <ul v-if="tooltipContent.specs">
                <li v-for="(spec, key) in tooltipContent.specs" :key="key">
                  <strong>{{ key }}:</strong> {{ spec }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>


      <!-- 标签页导航 - 移动到这里 -->
      <div class="product-tabs">
        <div class="tab-buttons">
          <button 
            v-for="tab in tabs" 
            :key="tab.id" 
            :class="{ 'active': currentTab === tab.id }"
            @click="currentTab = tab.id"
          >
            {{ tab.name }}
          </button>
        </div>
      </div>

      <!-- 标签页内容 - 保留在这里 -->
      <!-- 产品概览 -->
      <!-- <div v-if="currentTab === 'overview'" class="tab-content">
        <div class="product-info-container">
          <h2 class="product-feature-title">产品概述</h2>
          <div class="product-description-container">
            <div class="product-description" v-html="formattedDescription"></div>
          </div>
        </div>
      </div> -->

      <!-- 技术参数 -->
      <div v-if="currentTab === 'specs'" class="tab-content">
        <div v-if="product.techSpecs" class="tech-specs-section">
          <!-- 桌面端表格 -->
          <div class="tech-specs-container">
            <table class="tech-specs-table">
              <thead>
                <tr>
                  <th>{{ t('productDetail.paramName') }}</th>
                  <th>{{ t('productDetail.paramValue') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in product.techSpecs" :key="key">
                  <td>{{ key }}</td>
                  <td>{{ value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <!-- 移动端网格布局 -->
          <div class="tech-specs-grid">
            <div v-for="(value, key) in product.techSpecs" :key="key" class="tech-spec-item">
              <div class="tech-spec-name">{{ key }}</div>
              <div class="tech-spec-value">{{ value }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 尺寸详情 -->
      <div v-if="currentTab === 'dimensions'" class="tab-content">
        <div v-if="product.dimensionImageUrl" class="dimension-image-section">
          <div class="dimension-image-container">
            <img :src="product.dimensionImageUrl" :alt="t('productDetail.dimensionImage')" class="dimension-image">
          </div>
        </div>
      </div>

      <!-- 端口说明 暂不启用，和产品特点啊内容重合 -->
      <!-- <div v-if="currentTab === 'ports'" class="tab-content">
        <div v-if="product.portDescription" class="port-description-section">
          <h3>端口说明</h3>
          <div class="port-description" v-html="product.portDescription"></div>
        </div>
      </div> -->
      </div>

    <!-- 无数据状态 -->
    <div v-else class="no-data">
      {{ t('productDetail.noProduct') }}
    </div>
  </div>

  <!-- 页脚内容 -->
  <Footer />
</template>


<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { getProduct } from '@/api/product';
import ProductNavigation from '@/components/ProductNavigation.vue';
import Footer from '@/components/Footer.vue';
// 导入Element UI的图标组件
import { ElIcon } from 'element-plus';
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue';

const route = useRoute();
const { t, locale } = useI18n();
const product = ref(null);
const loading = ref(true);
const error = ref(null);
const currentTab = ref('specs');

// 标签页定义 - 使用翻译
const tabs = computed(() => [
  // { id: 'overview', name: t('productDetail.overview') },
  { id: 'specs', name: t('productDetail.technicalParams') },
  { id: 'dimensions', name: t('productDetail.dimensionDetails') }
]);

// 组件详情悬浮框状态
const showTooltip = ref(false);
const tooltipContent = ref({});
const tooltipPosition = ref({ x: 0, y: 0 });

// 格式化产品描述，处理换行和基本格式
const formattedDescription = computed(() => {
  if (!product.value?.description) return '';
  // 将换行符转换为<br>标签
  let html = product.value.description.replace(/\n/g, '<br>');
  return html;
});

// 提取加载产品详情为独立方法
const loadProductDetail = async () => {
  try {
    loading.value = true;
    error.value = null;
    const productId = route.params.id;
    if (!productId) {
      throw new Error(t('productDetail.noProductId'));
    }
    const response = await getProduct(productId, locale.value);
    if (!response.data) {
      throw new Error(t('productDetail.noProductData'));
    }
    if (!response.data.features) {
      response.data.features = [
        { id: 1, name: t('productDetail.feature1') },
        { id: 2, name: t('productDetail.feature2') },
        { id: 3, name: t('productDetail.feature3') },
        { id: 4, name: t('productDetail.feature4') }
      ];
    }
    product.value = response.data;
  } catch (err) {
    console.error('加载产品详情失败:', err);
    error.value = err.message || t('productDetail.loadFailed');
    product.value = null;
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  loadProductDetail();
});

watch(() => route.params.id, (newId, oldId) => {
  if (newId && newId !== oldId) {
    loadProductDetail();
  }
}, { immediate: false });

// 监听语言变化，重新加载产品数据
watch(() => locale.value, () => {
  if (route.params.id) {
    loadProductDetail();
  }
});

// 热区和悬浮框相关函数
// const getScaledCoords = (component) => {
//   if (!component.coords || !imageLoaded.value) return '';

//   const coords = component.coords.split(',').map(Number);
//   let scaledCoords = [];

//   if (component.shape === 'rect') {
//     // 矩形坐标: x1, y1, x2, y2
//     scaledCoords = [
//       coords[0] * scaleRatio.value.x,
//       coords[1] * scaleRatio.value.y,
//       coords[2] * scaleRatio.value.x,
//       coords[3] * scaleRatio.value.y
//     ];
//   } else if (component.shape === 'circle') {
//     // 圆形坐标: cx, cy, r
//     scaledCoords = [
//       coords[0] * scaleRatio.value.x,
//       coords[1] * scaleRatio.value.y,
//       coords[2] * scaleRatio.value.x  // 半径只需要x方向缩放
//     ];
//   }

//   // 转换为整数并拼接成字符串
//   return scaledCoords.map(Math.round).join(',');
// };

// 显示组件详情 - 添加错误处理
// const showComponentDetails = (component, event) => {
//   if (!component || !event) return;
//   tooltipContent.value = component;
//   showTooltip.value = true;
//   updateTooltipPosition(event);
// };

// 更新悬浮框位置 - 添加边界检查
// const updateTooltipPosition = (event) => {
//   if (!event || !event.currentTarget) {
//     return;
//   }

//   if (!productImage.value) return;

//   // 获取热区元素的位置信息
//   const hotspotElement = event.currentTarget;
//   const hotspotRect = hotspotElement.getBoundingClientRect();
//   // 获取图片容器元素
//   const container = productImage.value.parentElement;
//   const containerRect = container.getBoundingClientRect();

//   // 获取窗口尺寸
//   const windowWidth = window.innerWidth;
//   const windowHeight = window.innerHeight;

//   // 计算悬浮框基础位置（热区元素右侧）
//   let tooltipX = hotspotRect.left - containerRect.left + hotspotRect.width + 10;
//   let tooltipY = hotspotRect.top - containerRect.top;

//   // 边界检查 - 防止悬浮框超出窗口右侧
//   const tooltipWidth = 300; // 预估悬浮框宽度
//   if (hotspotRect.left + tooltipWidth > windowWidth) {
//     tooltipX = hotspotRect.left - containerRect.left - tooltipWidth - 10; // 显示在热区左侧
//   }

//   // 边界检查 - 防止悬浮框超出窗口底部
//   const tooltipHeight = 200; // 预估悬浮框高度
//   if (hotspotRect.top + tooltipHeight > windowHeight) {
//     tooltipY = Math.max(0, hotspotRect.top - containerRect.top - tooltipHeight + hotspotRect.height);
//   }

//   tooltipPosition.value.x = tooltipX;
//   tooltipPosition.value.y = tooltipY;
// };

// // 隐藏组件详情
// const hideComponentDetails = () => {
//   showTooltip.value = false;
// };

// 悬浮框样式计算 - 添加opacity控制
const tooltipStyle = computed(() => ({
  left: `${tooltipPosition.value.x}px`,
  top: `${tooltipPosition.value.y}px`,
  opacity: showTooltip.value ? 1 : 0,
  visibility: showTooltip.value ? 'visible' : 'hidden',
  transition: 'opacity 0.3s ease, visibility 0.3s ease'
}));

// // 计算热区样式 - 添加调试信息
// const getHotspotStyle = (component) => {
//   if (!component.coords || !imageLoaded.value) return {};

//   // 解析坐标字符串为数字数组
//   const coords = component.coords.split(',').map(Number);
//   let style = {};

//   if (component.shape === 'rect') {
//     // 矩形热区: x1, y1, x2, y2
//     const [x1, y1, x2, y2] = coords;
//     style = {
//       left: `${x1 * scaleRatio.value.x}px`,
//       top: `${y1 * scaleRatio.value.y}px`,
//       width: `${(x2 - x1) * scaleRatio.value.x}px`,
//       height: `${(y2 - y1) * scaleRatio.value.y}px`
//     };
//   } else if (component.shape === 'circle') {
//     // 圆形热区: cx, cy, r
//     const [cx, cy, r] = coords;
//     style = {
//       left: `${(cx - r) * scaleRatio.value.x}px`,
//       top: `${(cy - r) * scaleRatio.value.y}px`,
//       width: `${r * 2 * scaleRatio.value.x}px`,
//       height: `${r * 2 * scaleRatio.value.y}px`,
//       borderRadius: '50%'
//     };
//   }

//   return style;
// };

// 监听窗口大小变化，重新调整热点
watch(() => window.innerWidth, () => {
  if (imageLoaded.value) {
    // 延迟执行以确保DOM已更新
    setTimeout(adjustHotspots, 100);
  }
});

// 变量声明
const productImage = ref(null);
const imageLoaded = ref(false);
const originalImageSize = ref({ width: 0, height: 0 });
const displayedImageSize = ref({ width: 0, height: 0 });
const scaleRatio = ref({ x: 1, y: 1 });
const tooltipElement = ref(null);

// adjustHotspots函数定义
const adjustHotspots = () => {
  if (!productImage.value) return;

  // 获取图片原始尺寸和显示尺寸
  originalImageSize.value.width = productImage.value.naturalWidth;
  originalImageSize.value.height = productImage.value.naturalHeight;
  displayedImageSize.value.width = productImage.value.offsetWidth;
  displayedImageSize.value.height = productImage.value.offsetHeight;

  // 计算缩放比例
  scaleRatio.value.x = displayedImageSize.value.width / originalImageSize.value.width;
  scaleRatio.value.y = displayedImageSize.value.height / originalImageSize.value.height;

  imageLoaded.value = true;
};

// 图集相关状态
const currentImageIndex = ref(0);
const currentImageUrl = computed(() => {
  if (!product.value || !product.value.imageUrls || product.value.imageUrls.length === 0) {
    return product.value?.imageUrl || '@/assets/product1.png';
  }
  return product.value.imageUrls[currentImageIndex.value];
});
const imageCount = computed(() => {
  return product.value?.imageUrls?.length || 0;
});

// 切换到上一张图片
const prevImage = () => {
  if (currentImageIndex.value > 0) {
    currentImageIndex.value--;
    // 图片切换后重新调整热区
    setTimeout(() => adjustHotspots(), 100);
  }
};

// 切换到下一张图片
const nextImage = () => {
  if (product.value?.imageUrls && currentImageIndex.value < product.value.imageUrls.length - 1) {
    currentImageIndex.value++;
    // 图片切换后重新调整热区
    setTimeout(() => adjustHotspots(), 100);
  }
};

// 直接切换到指定图片
const switchToImage = (index) => {
  currentImageIndex.value = index;
  // 图片切换后重新调整热区
  setTimeout(() => adjustHotspots(), 100);
};

// 监听产品数据变化，重置图片索引
watch(() => product.value, (newVal) => {
  if (newVal) {
    currentImageIndex.value = 0;
  }
});
</script>

<style scoped lang="scss">
@import '@/styles/nav_section';
/* 原有产品页面样式 */
@import '@/styles/sections/homepage/main_menu';
@import '@/styles/sections/product_page/product_head';
@import '@/styles/sections/product_page/product_detail';
@import '@/styles/sections/homepage/footer_section';

/* 图集样式 */
.product-image-container {
  position: relative;
  /* 确保容器有足够空间容纳导航按钮 */
}

.image-carousel {
  position: relative;
  overflow: hidden;
  /* 根据需要设置尺寸 */
}

.image-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px 15px;
   cursor: pointer;
  z-index: 100; /* 大幅提高z-index值，确保按钮置顶显示 */
  transition: background-color 0.3s;
}

.image-nav-btn:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.prev-btn {
  left: 10px;
}

.next-btn {
  right: 10px;
}

.image-nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.image-indicators {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  gap: 10px;
}

.image-indicators span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ddd;
  cursor: pointer;
  transition: background-color 0.3s;
}

.image-indicators span.active {
  background-color: #333;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .image-nav-btn {
    padding: 8px 12px;
    font-size: 14px;
  }
  
  /* 产品描述移动端优化 */
  .overview-section {
    margin-top: 20px;
  }
  
  .product-description {
    max-height: 300px;
    overflow-y: auto;
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.6;
    word-wrap: break-word;
    word-break: break-word;
  }
  
  /* 产品标题容器移动端优化 */
  .product-title-container {
    padding: 0 15px;
  }
  
  .product-title-container h1 {
    font-size: 20px;
    margin-bottom: 15px;
  }
}

/* 小屏幕进一步优化 */
@media (max-width: 480px) {
  .product-description {
    max-height: 250px;
    padding: 12px;
    font-size: 13px;
  }
  
  .product-title-container h1 {
    font-size: 18px;
  }
}

/* 技术参数表格样式 */
.tech-specs-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 14px;
}

.tech-specs-table th,
.tech-specs-table td {
  padding: 12px 15px;
  border: 1px solid #e8e8e8;
  text-align: left;
}

.tech-specs-table th {
  background-color: #f7f7f7;
  font-weight: bold;
  color: #333;
}

.tech-specs-table tr:nth-child(even) {
  background-color: #fafafa;
}

.tech-specs-table tr:hover {
  background-color: #f5f5f5;
}

/* 隐藏原网格样式 */
.tech-specs-grid {
  display: none;
}

/* 普通手机屏幕 (最大宽度768px) */
@media (max-width: 768px) {
  /* 表格容器添加水平滚动以应对宽表格 */
  .tech-specs-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin: 0 -15px;
    padding: 0 15px;
  }
  
  /* 调整表格样式以适应移动设备 */
  .tech-specs-table {
    font-size: 13px;
    min-width: 500px; /* 确保表格内容不会过度挤压 */
  }
  
  .tech-specs-table th,
  .tech-specs-table td {
    padding: 10px 12px;
    white-space: nowrap; /* 防止内容换行导致表格过宽 */
  }
  
  /* 优化表格行悬停效果 */
  .tech-specs-table tr:hover {
    background-color: #f8f8f8;
  }
}

/* 小屏手机屏幕 (最大宽度480px) */
@media (max-width: 480px) {
  /* 对于非常小的屏幕，隐藏原表格，改用键值对网格布局 */
  .tech-specs-table {
    display: none;
  }
  
  /* 显示网格布局 */
  .tech-specs-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin-top: 20px;
  }
  
  /* 网格项样式 - 键值对形式 */
  .tech-spec-item {
    display: flex;
    flex-direction: column;
    padding: 12px;
    background-color: #fafafa;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  
  /* 参数名称样式 */
  .tech-spec-name {
    font-weight: bold;
    color: #333;
    margin-bottom: 4px;
    font-size: 13px;
  }
  
  /* 参数值样式 */
  .tech-spec-value {
    color: #666;
    font-size: 13px;
    line-height: 1.5;
  }
  
  /* 奇数项背景色不同，提高可读性 */
  .tech-spec-item:nth-child(odd) {
    background-color: #f0f0f0;
  }
}

/* 触摸设备优化 */
@media (hover: none) and (pointer: coarse) {
  /* 为触摸设备优化交互体验 */
  .tech-specs-table {
    -webkit-tap-highlight-color: transparent;
  }
  
  /* 触摸时的反馈效果 */
  .tech-specs-table tr:active {
    background-color: #f0f0f0;
  }
  
  .tech-spec-item:active {
    transform: scale(0.98);
    transition: transform 0.1s ease;
  }
}

/* 低分辨率设备优化 */
@media (max-width: 768px) and (-webkit-min-device-pixel-ratio: 2),
       (max-width: 768px) and (min-resolution: 192dpi) {
  /* 优化高分辨率屏幕上的表格边框显示 */
  .tech-specs-table th,
  .tech-specs-table td {
    border-width: 0.5px;
  }
}
</style>
